import logo from './logo.svg';
import './App.css';
import Blast from './Component/Blast';
import Annex from './Component/Annex';

function App() {
  return (
    <div className="App">
    <Annex/>
     <Blast/>
    </div>
  );
}

export default App;
